import React, { useEffect } from "react";
import "../Stylesheets/Hero.css";

import AOS from "aos";

const Hero = () => {

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <section
      className="hero min-vh-80 overflow-hidden"
    >
      <div className="container-fluid text-light">
        <div className="text-center d-flex flex-column align-items-center new-content">
          {/* <div className="d-inline-flex items-center border rounded-pill mb-4 p-1 " >
            <svg
              className="text-accent locationicon pe-1"
              fill="currentColor"
              viewBox="0 0 20 20"
              style={{ width: "100%", maxWidth: "30px" }}
            >
              <path
                fillRule="evenodd"
                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                clip-rule="evenodd"
              ></path>
            </svg>
            <span>
             
              Located at ELCOT IT SEZ, Madurai
            </span>
          </div> */}
          {/* <div data-aos="fade-down">
          <h1 className="name" style={{ fontWeight: "800", fontStyle: "" }}>
            TECH <span className="gradient-text">BRIDGE</span>
            <br />
           
          </h1>
          <div>
            <span
              className="fs-5 text-light tagline fw-bold"
              style={{ fontStyle: "oblique" }}
            >
              EDUCATE • EMPLOY • ELEVATE
            </span>
          </div>
          <p
            className="fs-5 text-light my-5 mx-auto"
            style={{ maxWidth: "58rem", lineHeight: "1.5" }}
            data-testid="hero-description"
          >
            Join our intensive training programs with industry experts. Get
            job-ready in 6 months and leverage our 1-year job placement opportunity{" "}
            <span className="mt-5">
          
            </span>
          </p>
          </div>

          <div class="mb-5 animate-scale-in-bounce delay-400">
            <div className="d-inline-flex align-items-center border rounded-pill px-4 py-2 gap-3 professional-glow prize-amount ">
              <a
                  href="https://nbmediatech.com/home"
                  target="_blank"
                  className="text-white fw-bold text-decoration-none "
                >
              <span class="fs-4 fw-bold" style={{ color: "rgb(0 253 255)" }}>
                100% GUARANTEED JOB PLACEMENT {" "}</span>
                
               <img src = "	https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/nblogo27300_IMG.png" style={{width:"100%",maxWidth:"50px"}}/>
                </a>             
            </div>
          </div> */}

          {/* <div data-aos="fade-up">
            <img className="heroimg mt-5" alt = "homeimage" src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge69646_IMG.png" />
          </div> */}

          {/* <div className="d-flex flex-column my-5 flex-sm-row justify-content-center gap-3">
            <a
              href="/6-month-program"
              className="btn gradient-bg text-white px-4 py-3  fw-semibold fs-5"
              data-testid="hero-cta-6month"
              style={{ borderRadius: "5rem" }}
            >
              6-Month Intensive Learning Program
            </a>

            <a
              href="/job-guarantee"
              className="btn  text-light px-4 py-3 rounded-lg fw-semibold fs-5 border border-border"
              style={{
                transition: "background-color 0.3s ease",
                borderRadius: "5rem",
              }}
              data-testid="hero-cta-jobguarantee"
            >
              1 Year Job Guarantee Program
            </a>
          </div> */}
        </div>
        {/* <div className="text-center mt-5 p-2 rounded-4 text-white position-relative overflow-hidden shadow-lg highlight-venue d-flex align-items-center justify-content-center gap-4">
          Left-side PNG image
          <img
            src={venue}
            alt="Location icon"
            className="venue-icon"
            data-testid="venue-icon"
          />

          Venue text
          <h1 className="fw-bold display-6 gradient-text-glow mb-0">
            Venue: ELCOT IT SEZ, Madurai
          </h1>
        </div> */}
    
        <div className="row">
          <div className="col-lg-1"></div>
          <div className="col-xl-6 d-flex align-items-center justify-content-center text-light flex-column" data-aos="fade-right">
            <h1 className=" gradient-text mb-3 text-center " style={{ fontFamily: "'Merriweather', serif", fontWeight: "700" }} >
              About Us
            </h1>
            <p className=" fs-5 mt-5" style={{ maxWidth: "85%", lineHeight: "2" }}>
              Tech Bridge is a career-focused internship platform created by NB Media Tech, a product-based IT company committed to developing industry-ready professionals.
              <p className="fw-bold mb-3">
                Our objective is simple:
              </p>

              <ul className="about-list"
                style={{
                  lineHeight: "1.8",
                  paddingLeft: "20px",
                }}
              >
                <li>
                  Bridge the gap between academic learning and real industry experience.
                </li>

                <li>
                  Provide practical exposure through live projects, professional
                  mentorship, and real workplace environments.
                </li>

                <li>
                  Develop technical knowledge, problem-solving skills, and confidence
                  through real business solutions.
                </li>

                <li>
                  Help freshers, graduates, and students become industry-ready
                  professionals.
                </li>
              </ul>
            </p>
          </div>
          {/* <div className="col-lg-1"></div> */}
          <div className="col-xl-5 mt-5 d-flex justify-content-center" data-aos="fade-left">
            <img
              src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge19663_IMG.png"
              alt="coding"
              className="glow-gif"
              style={{
                width: "80%",
                maxWidth: "800px",
                borderRadius: "16px",
              }}
            />
          </div>
          {/* <div
            className="col-lg-3 col-md-12"
            data-aos="fade-left"
          >
            <div className="about-image-wrapper">
              <img
                src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/techbridge30217_IMG.png"
                alt="Tech Bridge Students"
                className="about-image"
              />
            </div>
          </div> */}
        </div>

      </div>
    </section>
  );
};

export default Hero;
